module.exports = __webpack_public_path__ + "static/media/talleres.15d1bddf.jpg";